import { render, staticRenderFns } from "./subscriptiondetail.vue?vue&type=template&id=67334e73&"
import script from "./subscriptiondetail.vue?vue&type=script&lang=js&"
export * from "./subscriptiondetail.vue?vue&type=script&lang=js&"
import style0 from "./subscriptiondetail.vue?vue&type=style&index=0&id=67334e73&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports